import { use, useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { useWatch } from "react-hook-form"
import ReactJson from 'react-json-view'
import { submitBenefitPlanAudit, submitJobBenefitPlan, fetchGetApiRequestJobStatus } from "../../../utils/apiUtils";

import { useMultiStepFormStore } from "../../../store/multiStepFormStore";
import Modal from "../../modal/Modal";
import { Bounce, ToastContainer, toast } from 'react-toastify';
import { useAuthStore } from "../../../store/authStore";
import { ALL_INSTRUCTIONS } from "../../../utils/constants";
import { customStringify, delay } from "../../../utils/commonUtils";

const BenefitPlanPayload = ({ control, getValues, payload, errors, isValid, trigger }) => {
    const [activeSwitch, setActiveSwitch] = useState('PAYLOAD');
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('')
    const [collapsed, setCollapsed] = useState(1)
    const navigate = useNavigate()
    const { isAuthenticated, email } = useAuthStore()
    const { updatedAt, drafts, removeDraftByDraftId } = useMultiStepFormStore()
    const allFormValues = useWatch({ control })

    const submitHandler = async (body) => {
        try {
            setErrorMsg(null)
            setLoading(true)

            const isValid = await trigger(ALL_INSTRUCTIONS.filter(ins => ins.validation).map(ins => ins.validation).flat());

            if (!isValid) { throw new Error('Validation error') }
            const desireOrder = ['asOfDate', 'maintenanceInfo', 'maintenanceReasonCode', 'maintenanceComment', 'benefitPlan']
            const bodyString = customStringify(body, desireOrder);

            //submit job and get pk and sk
            const result = await submitJobBenefitPlan({ bodyString });

            let jobStatusRes

            do {
                await delay(3000)
                jobStatusRes = await fetchGetApiRequestJobStatus(result) // pass job pk and sk as params to get job status
                console.log(`requestStatus: ${jobStatusRes.requestStatus}`)
            } while (jobStatusRes.requestStatus === 'PENDING');

            const responseBody = jobStatusRes.responseBody
            if (responseBody.status === 'ERROR' || responseBody.status === 'FAILURE') {
                toast.error('Something went wrong!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                });
                //  const messageDescription = result[0].transactionInformation.exceptions.map(exp => `${exp.policyName} ${exp.messageDescription}`).join()
                throw new Error(responseBody?.errors?.error?.message || responseBody.status, { cause: responseBody })
            }

            toast.success(`${body?.benefitPlan?.benefitPlanHccId} has been updated with asOfDate: ${body?.asOfDate}`, {
                position: "top-right",
                autoClose: 8000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Bounce,
            });

            await submitBenefitPlanAudit({
                body: {
                    action: body.maintenanceInfo?.transactionType,
                    benefitPlanHccId: body.benefitPlan.benefitPlanHccId,
                    requestBody: bodyString,
                    responseBody,
                    //   result: result
                }
            });

            removeDraftByDraftId(allFormValues.draftId)
            navigate('/config/plans', {
                state: {
                    acount: allFormValues.account,
                    benefitPlanName: body.benefitPlan.benefitPlanName
                }
            })
        } catch (err) {
            console.log(err)
            setIsModalOpen({ message: err.cause || err.message })
        } finally {
            setLoading(false)
        }
    }

    const data = activeSwitch === 'FORMDATA' ? allFormValues :
        activeSwitch === 'PAYLOAD' ? payload :
            activeSwitch === 'ERRORS' ?
                Object.entries(errors).map(([key, err], index) => {
                    return { key, message: err.message, type: err.type }
                }) : {}

    return (
        <div>
            <Modal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            >
                <div style={{ padding: '1rem', width: '100%', overflowY: 'scroll', height: '100%' }}>
                    <ReactJson
                        style={{ padding: '1rem' }}
                        src={isModalOpen || {}}
                        name={false}
                        collapsed={3}
                        collapseStringsAfterLength={150}
                        displayDataTypes={false}
                        displayObjectSize={false}
                        sortKeys={true}
                    />
                </div>
            </Modal>

            <div>
                <p className="title">Payload</p>
                <p className="sub-title">Form data converted into benefit plan payload</p>

                <br />
                <div className="switch" style={{ width: 'fit-content' }}>
                    <p
                        className={`option ${activeSwitch === "PAYLOAD" ? "active" : ""}`}
                        onClick={() => setActiveSwitch("PAYLOAD")}>
                        Payload
                    </p>
                    <p
                        className={`option ${activeSwitch === "FORMDATA" ? "active" : ""}`}
                        onClick={() => setActiveSwitch("FORMDATA")}>
                        Formdata
                    </p>
                    <p
                        className={`option ${activeSwitch === "ERRORS" ? "active" : ""}`}
                        onClick={() => setActiveSwitch("ERRORS")}>
                        Errors
                    </p>
                </div>

                <br />
                <p className="success"
                    style={{ padding: '0rem 0rem 1rem 0rem', color: 'var(--green)', cursor: 'pointer' }}
                    onClick={() => setCollapsed(collapsed === 1 ? 5 : 1)}>
                    {collapsed == 1 ? 'Expand' : "Collapse"}
                </p>
                <ReactJson
                    src={data}
                    name={false}
                    collapsed={collapsed}
                    collapseStringsAfterLength={150}
                    displayDataTypes={false}
                    displayObjectSize={false}
                    groupArraysAfterLength={false}
                    sortKeys={activeSwitch === 'FORMDATA' ? true : false}
                />

                <p className="danger">{errorMsg}</p>

                <br />
                <br />
                {activeSwitch === 'PAYLOAD' ? <>{loading ? <div className="loader" /> : <button
                    className="btn"
                    onClick={async () => await submitHandler(payload)}
                    disabled={!isValid} //Object.keys(errors).length}
                >{allFormValues?.action === 'Create' ? 'Create' : 'Update'}</button>}</> : <></>}
            </div>
        </div>
    )
}

export default BenefitPlanPayload
